import React from "react";
import { COLOR_BLUE_BAYOUX } from "../../constants/styles";

import { Typography } from "../../UI/Typography";

const NoResults = props => (
  <Typography variant="body2" color={COLOR_BLUE_BAYOUX}>
    {props.text}
  </Typography >
);

NoResults.defaultProps = {
  text: "No results found"
};

export default NoResults;
